var map = {
	"./dayzero.png": "77a7",
	"./devops.png": "75ee",
	"./fullstack.png": "63b1",
	"./infrastructure.png": "8452",
	"./migration.png": "b355",
	"./mobility.png": "eeef",
	"./networking.png": "7a77",
	"./projects.png": "d709",
	"./security.png": "e05f",
	"./serverless.png": "a351"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a27e";